import { useQuery } from "@tanstack/react-query";

import { getStageTemplate } from "@/adapters/api";
import { toStageTemplate, toTemplateItem } from "../utils/map.ts";

export function useStageTemplate(templateId: string | undefined) {
	return useQuery({
		queryKey: ["stage-template", templateId],
		queryFn: async () => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			const response = await getStageTemplate(templateId!);
			return {
				template: toStageTemplate(response.template),
				items: response.items.map(toTemplateItem),
			};
		},
		enabled: !!templateId,
		retry: false,
		staleTime: 30_000,
	});
}
